import { Component, OnInit, ViewChild } from '@angular/core';
import * as AOS from 'aos';
import { NgxTypedJsComponent } from 'ngx-typed-js';


export interface P1Data {

  // form Start
  _id: number;
  imageUrl: string;
  productIcon: string;
  productName: string;
  productDes: string;
}

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {
// img = '';

@ViewChild(NgxTypedJsComponent, { static: true }) typed: NgxTypedJsComponent;
doSmth(): void {
  this.typed.start();
}
  constructor() { }


  data = [

    {
      "_id": 1,
      "imageUrl": "../../../../assets/img/icons/product_icon/online-exam-portal-500x500.jpg",
      "productIcon": "../../../../assets/img/icons/product_icon/exam_port.png",
      "productName": "Exam Portal",
      "productDes": " Online Exam Portal which will help in conducting the Online Examination. The project has been developed using Angular 9 as a front end and Node, express & mongoDB used for backend."
    },
    {
      "_id": 2,
      "imageUrl": "../../../../assets/img/icons/product_icon/erp-software_portal.jpg",
      "productIcon": "../../../../assets/img/icons/product_icon/erp_soft.png",
      "productName": "ERP SOFTWARE",
      "productDes": " Enterprise resource planning is the integrated management of main business processes, College ERP system where managed college using this ERP."
    },
    {
      "_id": 3,
      "imageUrl": "../../../../assets/img/icons/product_icon/e-learning-portal.png",
      "productIcon": "../../../../assets/img/icons/product_icon/e-learning.png",
      "productName": "E-learning Portal",
      "productDes": "E-Learning today has taken the world by storm and helped make learning on-the-go, a norm. Today, learners have access to multiple forms of content which aim to engage the learner."
    },
    // {
    //   "_id": 4,
    //   "imageUrl": "../../../../assets/img/test/live_classes.jpg",
    //   "productIcon": "fa fa-shopping-cart",
    //   "productName": "Live Classes Software",
    //   "productDes": " Get your coaching institute online today. Conduct live & video classes for your students. Sell online courses and collect fees. Manage multiple batches. Student forum for doubts. Live & Recorded Classes."
    // },

    // {
    //   "_id": 5,
    //   "imageUrl": "../../../../assets/img/test/inventory.webp",
    //   "productIcon": "fa fa-life-bouy",
    //   "productName": "Inventory Software",
    //   "productDes": " Inventory management software is software designed to track and manage items through various stages along the supply chain. Depending on the complexity of your asset tracking and physical inventory needs"
    // },
    // {
    //   "_id": 6,
    //   "imageUrl": "../../../../assets/img/test/ecommerce-sol.jpeg",
    //   "productIcon": "fa fa-line-chart",
    //   "productName": "Ecommerce Solutions",
    //   "productDes": "All-in-one ecommerce solutions. Ecommerce website builder & online shopping cart system that has every features you need to run your online business."
    // },


]

  ngOnInit(): void {
    AOS.init();
     console.log(this.data);
  }

}
